
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/utils/Button";
import { Link } from "react-router-dom";
import genericActions from "../../redux/generic/actions";
import CardLayout from "../../components/utils/CardLayout";
import { useDispatch, useSelector } from "react-redux";
import { twoDigitDecimal } from "../../helpers/commonFunction";
import ActivationActions from "../../redux/activation/actions";
import ToastAlert from "../../components/utils/ToastAlert";

const { createBulkActivation, resetMessage } = ActivationActions;
const { getPlan, getBillingCode } = genericActions;

const SimActivation = () => {
  const dispatch = useDispatch();
  const { planList, getPlanLoading, billingCodeList } = useSelector((state) => state.generic);
  const { bulkActivationFResponse, bulkActivationLoading, bulkActivationMessage, bulkActivationError } = useSelector((state) => state.activation);

  const [selectedPlan, setSelectedPlan] = useState({})
  const [activeTab, setActiveTab] = useState(1);

  console.log("bulkActivationFResponse==>>", bulkActivationFResponse)


  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      serialnumber: "",
      planId: "",
      billingCode: "",
      streetAddress1: "",
      streetAddress2: "",
      city: "",
      state: "",
      zipCode: "",
    },
  });

  const watchPlanId = watch('planId');

  useEffect(() => {
    if (watchPlanId) {
      const planData = planList.find(
        (item) => item?.PlanID == watchPlanId
      );
      setActiveTab(2)
      setSelectedPlan(planData);
    }
  }, [watchPlanId, planList]);

  useEffect(() => {
    dispatch(getPlan({ ActionType: 1, Month: 1 }))
    dispatch(getBillingCode({ ActionType: 1 }))

    return () => {
      dispatch(resetMessage());
    };
  }, [])


  useEffect(() => {
    if (bulkActivationMessage) {
      ToastAlert({ type: "success", text: bulkActivationMessage });
      handleReset();
    }

    if (bulkActivationError) {
      ToastAlert({ type: "error", text: (bulkActivationFResponse && bulkActivationFResponse.length > 0 && bulkActivationFResponse[0]?.ResponseMsg) || bulkActivationError });
    }
  }, [bulkActivationMessage, bulkActivationError, bulkActivationFResponse]);



  const onSubmit = async (data) => {
    const payload = {
      "planId": Number(data?.planId) || 0,
      "billingCode": data?.billingCode,
      "requestType": 1,
      "sims": [
        {
          "iccid": data?.serialnumber,
          "zipcode": data?.zipCode,
          "street1": data?.streetAddress1,
          "street2": data?.streetAddress2 || '',
          "city": data?.city,
          "state": data?.state,
        }
      ]
    }
    console.log('payload==>>', payload);

    dispatch(createBulkActivation(payload))
  };


  const handleReset = () => {
    reset()
    dispatch(resetMessage())
    setActiveTab(1)
    setSelectedPlan({})
  }

  return (
    <CardLayout
      title={<> SIM Activation</>}
      icon="ri-file-chart-line "
    >
      <div className="row">
        {/* Left Side */}
        <div className="col-lg-3 left-panel">
          <div className="quick-links">
            <div className="d-flex justify-content-between">
              <button type="button" onClick={() => setActiveTab(1)}>
                <h5 className="quick-title">Quick Links</h5>
                {activeTab == 1 ? <div className="title-line"></div> : <div className="mb-4"></div>}
              </button>

              <button type="button" onClick={() => setActiveTab(2)}>
                <h5 className="quick-title">Plan Summary</h5>
                {activeTab == 2 ? <div className="title-line"></div> : <div className="mb-4"></div>}
              </button>
            </div>
            {activeTab == 1 && <>
              <Link to="/activation/bulk-activation" className="quick-link">
                <div>
                  <i className="fa-solid fa-layer-group"></i>
                  <span>Bulk Activation</span>
                </div>
                <i className="fa-solid fa-angle-right"></i>
              </Link>

              <a href="/checkstatus/check-status" className="quick-link">
                <div>
                  <i className="fa-solid fa-circle-check"></i>
                  <span>Check Status</span>
                </div>

                <i className="fa-solid fa-angle-right"></i>
              </a>

              <a href="/reports/activation-report" className="quick-link">
                <div>
                  <i className="fa-solid fa-chart-column"></i>
                  <span>Activation Report</span>
                </div>

                <i className="fa-solid fa-angle-right"></i>
              </a>

              <a href="/wifi/wifi-activation" className="quick-link">
                <div>
                  <i className="fa-solid fa-wifi"></i>
                  <span>WiFi</span>
                </div>

                <i className="fa-solid fa-angle-right"></i>
              </a>
            </>}

            {activeTab == 2 && <>
              <div className="d-flex flex-column gap-3">

                <div className="d-flex align-items-center justify-content-between 
                  border rounded-3 px-3 py-3 bg-light">
                  <div className="d-flex align-items-center gap-2">
                    <i className="fa-solid fa-tag text-primary"></i>
                    <span className="text-dark fw-semibold">Plan Price</span>
                  </div>

                  <span className="text-primary fw-bold">${twoDigitDecimal(selectedPlan?.PlanAmount)}</span>
                </div>

                <div className="d-flex align-items-center justify-content-between 
                  border rounded-3 px-3 py-3 bg-light">
                  <div className="d-flex align-items-center gap-2">
                    <i className="fa-solid fa-hand-holding-dollar text-primary"></i>
                    <span className="text-dark fw-semibold">Dealer Cost</span>
                  </div>

                  <span className="text-primary fw-bold">${twoDigitDecimal(selectedPlan?.DealerCost)}</span>
                </div>

              </div>
            </>}

          </div>
        </div>

        {/* Right Side */}
        <div className="col-lg-9">
          <form
            onSubmit={handleSubmit(onSubmit)}
            noValidate

          >
            <div className="row">
              {/* Serial Number */}

              <div className="col-lg-4 mb-2">
                <label className="form-label fw-semibold">
                  Serial Number <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className={`form-control ${errors.serialnumber ? "is-invalid" : ""
                    }`}
                  placeholder="Serial Number"
                  {...register("serialnumber", {
                    required: "Serial Number is required",
                    pattern: {
                      value: /^[0-9]{19}$/,
                      message: "Serial Number must be exactly 19 digits",
                    },
                  })}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, ""); // allow only numbers
                  }}
                />

                <div className="invalid-feedback"> {errors.serialnumber?.message} </div>
              </div>

              {/* Plan */}

              <div
                className="col-lg-4 mb-2"
              >
                <label className="form-label fw-semibold">
                  Plan <span className="text-danger">*</span>
                </label>

                <select
                  className={`form-select ${errors.planId ? "is-invalid" : ""
                    }`}
                  disabled={getPlanLoading}
                  {...register("planId", {
                    required: "Plan is required",
                  })}
                >
                  {getPlanLoading ? (
                    <option>Loading Plan...</option>
                  ) : (
                    <>
                      <option value="">Select Plan</option>
                      {planList?.map((item) => (
                        <option key={item?.PlanID} value={item?.PlanID}>
                          {item?.PlanName}
                        </option>
                      ))}
                    </>
                  )}
                </select>

                <div className="invalid-feedback"> {errors.planId?.message} </div>
              </div>


              {/* Billing Code */}

              <div
                className="col-lg-4 mb-2"
              >
                <label className="form-label fw-semibold">
                  Billing Code <span className="text-danger">*</span>
                </label>

                <select
                  className={`form-select ${errors.billingCode ? "is-invalid" : ""
                    }`}
                  {...register("billingCode", {
                    required: "Billing code is required",
                  })}
                >
                  <option value="">Select Billing Code</option>
                  {billingCodeList && billingCodeList.length > 0 && billingCodeList.map((item) => (
                    <option key={item?.BillingCode} value={item?.BillingCode}>
                      {item?.BillingCode}
                    </option>
                  ))}
                </select>
                <div className="invalid-feedback"> {errors.billingCode?.message} </div>
              </div>

              {/* Zip Code */}

              <div
                className="col-lg-4 mb-2"
              >
                <label className="form-label fw-semibold">
                  ZIP Code <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className={`form-control ${errors.zipCode ? "is-invalid" : ""
                    }`}
                  placeholder="ZIP Code"
                  {...register("zipCode", {
                    required: "ZIP Code is required",
                    // pattern: {
                    //   value: /^\d{5}(-\d{4})?$/,
                    //   message: "Invalid ZIP Code",
                    // },
                  })}
                />

                <div className="invalid-feedback"> {errors.zipCode?.message} </div>
              </div>

              {/* Address 1 */}
              <div
                className="col-lg-4 mb-2"
              >
                <label className="form-label fw-semibold">
                  Street Address 1 <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className={`form-control ${errors.streetAddress1 ? "is-invalid" : ""
                    }`}
                  placeholder="Street Address 1"
                  {...register("streetAddress1", {
                    required: "Street Address 1 is required",
                  })}
                />

                <div className="invalid-feedback"> {errors.streetAddress1?.message} </div>
              </div>

              {/* Address 2 */}
              <div
                className="col-lg-4 mb-2"
              >
                <label className="form-label fw-semibold">
                  Street Address 2
                </label>

                <input
                  type="text"
                  className={`form-control ${errors.streetAddress2 ? "is-invalid" : ""
                    }`}
                  placeholder="Street Address 2"
                  {...register("streetAddress2", {
                  })}
                />
                <div className="invalid-feedback"> {errors.streetAddress2?.message} </div>
              </div>

              {/* City */}
              <div
                className="col-lg-4 mb-2"
              >
                <label className="form-label fw-semibold">
                  City <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className={`form-control ${errors.city ? "is-invalid" : ""
                    }`}
                  placeholder="City"
                  {...register("city", {
                    required: "City is required",
                  })}
                />

                <div className="invalid-feedback"> {errors.city?.message} </div>
              </div>

              {/* State */}
              <div
                className="col-lg-4 mb-2"
              >
                <label className="form-label fw-semibold">
                  State <span className="text-danger">*</span>
                </label>

                 <input
                  type="text"
                  className={`form-control ${errors.state ? "is-invalid" : ""
                    }`}
                  placeholder="State"
                  {...register("state", {
                    required: "State is required",
                  })}
                />

                <div className="invalid-feedback"> {errors.state?.message} </div>
              </div>

              {/* Submit */}
              <div
                className="d-flex justify-content-end mt-3 gap-2"
              >
                <Button
                  buttonType="button"
                  title="Reset"
                  disable={bulkActivationLoading}
                  variant="secondary"
                  icon={<i className="ri-refresh-line me-2"></i>}
                  onClick={handleReset}
                />

                <Button
                  buttonType="submit"
                  title={bulkActivationLoading ? "Submitting..." : "Submit"}
                  loading={bulkActivationLoading}
                  icon={<i className="ri-send-plane-fill me-2"></i>}
                />
              </div>

            </div>
          </form>
        </div>
      </div>
    </CardLayout>
  );
};

export default SimActivation;
